import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';

import { CdwDrawerComponent } from './cdw-drawer/cdw-drawer.component';

@NgModule({
  imports: [CdwIconModule, CdwButtonModule, CommonModule, MaterialLibraryModule],
  declarations: [CdwDrawerComponent],
  exports: [CdwDrawerComponent],
})
export class CdwDrawerModule {}